"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticUtility = exports.LiveStreamActionType = void 0;
var EventType;
(function (EventType) {
    EventType["UI"] = "UI Events";
    EventType["UI_ERROR"] = "UI Error";
    EventType["LIVESTREAM"] = "Livestream Events";
    EventType["LIVESTREAM_ERROR"] = "Livestream Error";
    EventType["SOCIAL_CLICK"] = "Social Clicks";
    EventType["ERROR_404"] = "404 Error";
})(EventType || (EventType = {}));
var LiveStreamActionType;
(function (LiveStreamActionType) {
    LiveStreamActionType[LiveStreamActionType["PLAY"] = 0] = "PLAY";
    LiveStreamActionType[LiveStreamActionType["PAUSE"] = 1] = "PAUSE";
    LiveStreamActionType[LiveStreamActionType["ENDED"] = 2] = "ENDED";
    LiveStreamActionType[LiveStreamActionType["TIMEUPDATE"] = 3] = "TIMEUPDATE";
})(LiveStreamActionType = exports.LiveStreamActionType || (exports.LiveStreamActionType = {}));
var AnalyticUtility = /** @class */ (function () {
    function AnalyticUtility(region, isApp) {
        if (isApp === void 0) { isApp = false; }
        Object.defineProperty(this, "_region", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'US'
        });
        Object.defineProperty(this, "_isApp", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        this._region = region || 'US';
        this._isApp = isApp;
    }
    Object.defineProperty(AnalyticUtility.prototype, "subscribeSuccess", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.sendEvent(EventType.UI, 'Form Success (Subscribe)', 'Success without FF 91 Interest');
        }
    });
    Object.defineProperty(AnalyticUtility.prototype, "subscribeError", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (message) {
            this.sendError(EventType.UI_ERROR, 'Subscribe Form Error', message);
        }
    });
    Object.defineProperty(AnalyticUtility.prototype, "trackUIEvent", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (action, label) {
            this.sendEvent(EventType.UI, action, label);
        }
    });
    Object.defineProperty(AnalyticUtility.prototype, "trackUIEventError", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (action, label) {
            this.sendError(EventType.UI_ERROR, action, label);
        }
    });
    Object.defineProperty(AnalyticUtility.prototype, "trackLivestreamEvent", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (action, source, duration) {
            this.sendEvent(EventType.LIVESTREAM, LiveStreamActionType[action].toLowerCase(), source, duration);
        }
    });
    Object.defineProperty(AnalyticUtility.prototype, "trackLivestreamError", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (source, error) {
            this.sendError(EventType.LIVESTREAM_ERROR, source, error);
        }
    });
    Object.defineProperty(AnalyticUtility.prototype, "trackSocialClickEvent", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (platform, url) {
            this.sendEvent(EventType.SOCIAL_CLICK, platform, url);
        }
    });
    Object.defineProperty(AnalyticUtility.prototype, "trackError404", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (page) {
            this.sendEvent(EventType.ERROR_404, 'page_load', page);
        }
    });
    Object.defineProperty(AnalyticUtility.prototype, "bookingSuccess", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (withEmail, confirmationNum) {
            var label = withEmail ? 'Success with Email Sign up' : 'Success without Email Sign up';
            this.sendEvent(EventType.UI, "Booking Success - " + confirmationNum, label);
        }
    });
    Object.defineProperty(AnalyticUtility.prototype, "bookingError", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (error) {
            this.sendError(EventType.UI_ERROR, 'Standard Reservation Form Error', error);
        }
    });
    Object.defineProperty(AnalyticUtility.prototype, "reserveSuccess", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (withEmail, confirmationNum, price) {
            var label = withEmail ? 'Success with Email Sign up' : 'Success without Email Sign up';
            this.sendEvent(EventType.UI, "Reserve Form Success - " + confirmationNum, label, price);
        }
    });
    Object.defineProperty(AnalyticUtility.prototype, "reserveError", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (error) {
            this.sendError(EventType.UI_ERROR, 'Priority Reservation Form Error', error);
        }
    });
    Object.defineProperty(AnalyticUtility.prototype, "paidReservationFormSelected", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.sendEvent(EventType.UI, 'Paid Reservation Form Selected', 'Reservation Form');
        }
    });
    Object.defineProperty(AnalyticUtility.prototype, "standardReservationFormSelected", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.sendEvent(EventType.UI, 'Standard Reservation Form Selected', 'Reservation Form');
        }
    });
    Object.defineProperty(AnalyticUtility.prototype, "registerSuccess", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.sendEvent(EventType.UI, 'Register success');
        }
    });
    Object.defineProperty(AnalyticUtility.prototype, "registerError", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (error) {
            this.sendError(EventType.UI_ERROR, 'Register error', error);
        }
    });
    Object.defineProperty(AnalyticUtility.prototype, "sendError", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event, action, error) {
            this.sendEvent(event, action, error);
        }
    });
    Object.defineProperty(AnalyticUtility.prototype, "sendEvent", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event, action, label, value) {
            var _a, _b;
            var actionWithDeviceSuffix = action + "_" + (this._isApp ? 'app' : 'web');
            try {
                if (this._region === 'CN') {
                    (_a = window === null || window === void 0 ? void 0 : window._hmt) === null || _a === void 0 ? void 0 : _a.push(['_trackEvent', event, actionWithDeviceSuffix, label || '', value]);
                }
                else {
                    (_b = window === null || window === void 0 ? void 0 : window.dataLayer) === null || _b === void 0 ? void 0 : _b.push({
                        event: event,
                        action: actionWithDeviceSuffix,
                        label: label,
                        value: value
                    });
                }
            }
            catch (error) {
                console.error('send analytic event failed', error);
            }
        }
    });
    return AnalyticUtility;
}());
exports.AnalyticUtility = AnalyticUtility;
